import { SendVerificationTokenResponse } from '../../gql/graphql';
import { createForbiddenErrorMessage, createUnauthorizedErrorMessage } from '../../helpers/security/security';
import authService from '../../services/auth.service';
import { NetworkError } from '../../state-machine/actions/genericActions';

const sendCode = async (cellPhone: string): Promise<SendVerificationTokenResponse> => {
  try {
    const resp: any = await authService.sendVerificationToken(cellPhone);
    return resp.data.sendVerificationToken;
  } catch (err: any) {
    var error = {} as NetworkError;
    switch (err?.networkError?.statusCode) {
      case 403:
        error.forbiddenError = createForbiddenErrorMessage(err);
        break;
      case 401:
        error.unauthorizedError = createUnauthorizedErrorMessage(err);
        break;
      default:
        error.errorGeneral = err;
    }
    throw error;
  }
};

export default sendCode;
